import ActionType from './ActionType';
import { MeshFiles } from '../apis/meshApi';

export interface DataAction {
  type: ActionType.SET_MESH_FILES_PLATFORM;
  data: MeshFiles;
}

export const initialMeshFilesPlatform: MeshFiles = [];

export const meshFilesPlatformReducer = (state: MeshFiles, action: DataAction) => {
  switch (action.type) {
    case ActionType.SET_MESH_FILES_PLATFORM:
      // console.log('setting SET_MESH_FILES_PLATFORM in meshFilesReducer: ', action.data);
      return action.data;
    default:
      return state;
  }
};
